import InlineSvg from 'vue-inline-svg'

export function initInlineSvg(app) {
    app.component('InlineSvg', InlineSvg)
}
